import { BlockPointAttribute } from '@collector/sportsapi-client-legacy'

export const zones = new Map<number, BlockPointAttribute>([
  [1, BlockPointAttribute.Zone1],
  [2, BlockPointAttribute.Zone2],
  [3, BlockPointAttribute.Zone3],
  [4, BlockPointAttribute.Zone4],
  [5, BlockPointAttribute.Zone5],
  [6, BlockPointAttribute.Zone6],
])
